<template>
  <div>
    <h3 class="mt-6 mb-4 text-base">
      Funding Allocation
    </h3>
    <bar-chart
      :chart-data="chartData"
      :options="chartOptions"
      class="w-full"
      style="height: 24rem"
    />
  </div>
</template>

<script>
export default {
  name: "FundingSplitAllocation",
  props: {
    allocation: {
      type: Array,
      required: true
    }
  },
  computed: {
    chartData() {
      return {
        labels: this.companies,
        datasets: [
          {
            label: "Remaining",
            backgroundColor: "#97D700",
            data: this.remaining || 0
          },
          {
            label: "Used",
            backgroundColor: "#F5FBE6",
            data: this.used || 0
          },
          {
            label: "Requested",
            backgroundColor: "#DBDBDB",
            data: this.requested || 0
          }
        ]
      };
    },
    companies() {
      return this.allocation.reduce((arr, company) => {
        arr.push(company.name);
        return arr;
      }, []);
    },
    remaining() {
      return this.allocation.reduce((arr, company) => {
        arr.push(company.remaining.toFixed(2));
        return arr;
      }, []);
    },
    used() {
      return this.allocation.reduce((arr, company) => {
        arr.push(company.used.toFixed(2));
        return arr;
      }, []);
    },
    requested() {
      return this.allocation.reduce((arr, company) => {
        arr.push(company.requested.toFixed(2));
        return arr;
      }, []);
    },
    chartOptions() {
      return {
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              stacked: true,
              display: false
            }
          ],
          yAxes: [
            {
              stacked: true,
              barThickness: 30
            }
          ]
        }
      };
    }
  }
};
</script>
